import { Player } from "./player";

export type { Player };

export const player = new Player();
